import { TableCell, TableRow, useTheme } from '@mui/material';

export const EmptyRows = (props: {
  numberOfCurrentRows: number,
  height: number;
  colSpan?: number;
}) => {
  const theme = useTheme();

  return <>{
    Array.from({ length: Math.max(0, 10 - props.numberOfCurrentRows) }).map((_, index) => (
      <TableRow key={`empty-row-${index}`}
        sx={{ height: `${props.height}px`, backgroundColor: theme.palette.common.white }}>
        <TableCell colSpan={props.colSpan ?? 6}
          sx={{
            backgroundColor: theme.palette.common.white,
            borderColor: index === Math.max(0, 10 - props.numberOfCurrentRows) - 1 ? theme.palette.custom.gray[100] : theme.palette.common.white,
          }} />
      </TableRow>
    ))
  }</>;
};